import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "./game-wrapper.css";
import { v4 as uuidv4 } from 'uuid';
import { gameStore } from "../../../platform/games/game.store";
import { reportApiService } from "../../../platform/api/report.api.service";

export const GameWrapper = () => {
  const { skin, game } = useParams();
  const [url, setUrl] = useState('');

  useEffect(() => {
    const launchUrl = buildLaunchUrl(game, skin);
    setUrl(launchUrl);
    report().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const report = async () => {
    try {
      await reportApiService.report({
        locationHref: window.location.href,
        env: process.env.REACT_APP_ENVIRONMENT,
      });
      console.log('ok');
    } catch {
      console.log('err');
    }
  }

  const buildLaunchUrl = (gameName: string | undefined, skin: string | undefined): string => {
    const game = gameStore.games.find(e => e.uniqueName === gameName);
    if (!game) {
      window.location.replace('https://astriona.games');
      return '';
    }

    const baseUrl = process.env.REACT_APP_BASE_URL;
    return `${baseUrl}/launcher/string/launch?gameId=${game.id}&currency=USD&operatorId=1&casinoId=1&token=222&languageCode=en&playerId=${uuidv4()}&skin=${skin || ''}`;
  }

  return (
    <div className="game-wrapper">
      <iframe src={url} title="Astriona"></iframe>
    </div>
  );
}